import { DEFAULT_DEV_SUBSCRIPTION_TIER } from '../constants/devFlags';

export const SUBSCRIPTION_STATUS_CLAIM = 'https://softwareiq.io/subscriptionStatus';
export const SUBSCRIPTION_TIER_CLAIM = 'https://softwareiq.io/subscriptionTier';
export const MANUAL_RESEARCH_GRANT_CLAIM = 'https://softwareiq.io/manualResearchGrant';

export const getEligibleManualResearchGrant = (user = {}) => {
  const grant = user?.[MANUAL_RESEARCH_GRANT_CLAIM];
  const email = user?.['https://softwareiq.io/email'];
  return grant?.status === 'active'
    && ['trial', 'enterprise'].includes(grant.kind)
    && (grant.kind !== 'enterprise' || (typeof grant.contractId === 'string' && grant.contractId.length > 0))
    && user?.['https://softwareiq.io/email_verified'] === true
    && typeof email === 'string' && typeof grant.approvedEmail === 'string'
    && email.trim().toLowerCase() !== ''
    && email.trim().toLowerCase() === grant.approvedEmail.trim().toLowerCase()
    ? grant : null;
};

export const SUBSCRIPTION_TIERS = {
  FREE: 'free',
  CORE: 'core',
  RESEARCH: 'research',
};

export const isCoreSubscriptionStatus = (status) => (
  status === 'active' || status === 'trialing' || status === 'past_due'
);

const VALID_SUBSCRIPTION_TIERS = new Set(Object.values(SUBSCRIPTION_TIERS));

export const getDevSubscriptionTier = ({
  nodeEnv = process.env.NODE_ENV,
  configuredTier = process.env.REACT_APP_DEV_SUBSCRIPTION_TIER,
} = {}) => {
  if (nodeEnv !== 'development') return null;
  return VALID_SUBSCRIPTION_TIERS.has(configuredTier)
    ? configuredTier
    : DEFAULT_DEV_SUBSCRIPTION_TIER;
};

export const resolveSubscriptionEntitlements = (user = {}, options = {}) => {
  const devSubscriptionTier = VALID_SUBSCRIPTION_TIERS.has(options.devSubscriptionTier)
    ? options.devSubscriptionTier
    : null;
  const subscriptionStatus = devSubscriptionTier
    ? (devSubscriptionTier === SUBSCRIPTION_TIERS.FREE ? 'free' : 'active')
    : user?.[SUBSCRIPTION_STATUS_CLAIM] || 'free';
  const claimedTier = devSubscriptionTier || user?.[SUBSCRIPTION_TIER_CLAIM];
  const manualAccess = !devSubscriptionTier && Boolean(getEligibleManualResearchGrant(user));
  const paidAccess = isCoreSubscriptionStatus(subscriptionStatus);
  const hasCoreAccess = paidAccess || manualAccess;
  const hasResearchAccess = manualAccess || (paidAccess
    && claimedTier === SUBSCRIPTION_TIERS.RESEARCH);

  return {
    subscriptionStatus,
    subscriptionTier: hasResearchAccess
      ? SUBSCRIPTION_TIERS.RESEARCH
      : hasCoreAccess
        ? SUBSCRIPTION_TIERS.CORE
        : SUBSCRIPTION_TIERS.FREE,
    hasCoreAccess,
    hasResearchAccess,
  };
};
